import { useQuery } from '@apollo/client';
import gql from 'graphql-tag';

import { useSelector } from '~Hooks';
import { GetOffers, GetOffersVariables } from './__queries__';

const GET_OFFERS = gql`
  query GetOffers($companyId: ID!) {
    Company(id: $companyId) {
      id
      offers(context: [POS]) {
        id
        name
        type
        enabled
        deleted
        discountRate
        discountType
        overrideItemPrices

        nameLang {
          id
          se
          en
          es
          no
        }

        items(filter: { deleted: false }) {
          id
          titleLang {
            id
            se
            en
            es
            no
          }
        }

        categories {
          id
          items {
            id
          }
        }

        stages {
          id
          title {
            id
            se
            en
            es
            no
          }
          items(filter: { deleted: false }) {
            id
          }
        }
      }
    }
  }
`;

export default function useOffers() {
  const companyId = useSelector((state) => state.company);

  const { data, loading } = useQuery<GetOffers, GetOffersVariables>(GET_OFFERS, {
    variables: { companyId },
    skip: !companyId,
  });

  const filteredOffers =
    data?.Company?.offers.filter((offer) => !offer.deleted && offer.enabled) || [];

  return {
    /**
     * All offers for active company
     */
    offers: filteredOffers || [],
    /**
     * Boolean. Indicates if the query is loading
     */
    loading,
  };
}
